/* eslint-disable react-hooks/rules-of-hooks */
import useDefaultSWR, { cache, mutate as defaultMutate } from 'swr'

export const mutate = async (key, data, shouldRevalidate = false) => defaultMutate(key, data, shouldRevalidate)

const fiveHoursInMs = 18000000

const useSWR = (path, query, config = {}) => {
  if (!path) return useDefaultSWR()

  let url = path

  if (query) {
    const queryString = Object.keys(query)
      .filter((key) => key !== 'text' || query[key].length >= 3)
      .sort((a, b) => (a > b ? 1 : -1))
      .map((key) => {
        let val = query[key]

        if (typeof val === 'object' && !Array.isArray(val)) val = JSON.stringify(val)

        return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
      })
      .join('&')

    url += `?${queryString}`
  }

  const defaultConfig = {
    revalidateOnFocus: false,
    revalidateOnMount: !cache.get(url),
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
    refreshInterval: fiveHoursInMs,
  }

  const { error, data, mutate: m, isValidating } = useDefaultSWR(url, { ...defaultConfig, ...config })

  return { error, data, mutate: (func, shouldRevalidate = false) => m(func, shouldRevalidate), isValidating }
}

export default useSWR
